import bootstrap from 'bootstrap'
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

export const CustomModal = forwardRef((props: any, ref:any) => {
  const intl = useIntl()
   useImperativeHandle(ref, () => ({
      open() {
        setShow(true)
      },
      close() {
        setShow(false)
      }
    }));
  const title = props.title ? props.title : 'Modal title'
  const show_close = props.show_close ? props.show_close : true
  const children = props.children ? props.children : null
  const button:Array<ButtonType> = props.buttons ? props.buttons : []
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {children}
          </Modal.Body>
          <Modal.Footer>
            {button.map((b:ButtonType, index:number) => {
              return <button key={index} className={"btn btn-"+b.color} onClick={b.action}>{b.title}</button>
            })}
            {show_close && <button className="btn btn-secondary" onClick={handleClose}>{intl.formatMessage({id: 'GENERIC.UNDO'})}</button>}
          </Modal.Footer>
      </Modal>
    </>
  )
});



export type ButtonType = {
  title: string,
  color: string,
  action: () => void
}